import api from '@sparemin/api-sdk';
import { normalize, schema } from 'normalizr';

import * as types from './types';

export const recordingSchema = new schema.Entity(
  'recordings',
  {},
  {
    idAttribute: 'recordingId',
  },
);

const updateRecording = async (
  args: types.UpdateRecordingArgs,
): Promise<types.UpdateRecordingResult> => {
  const [recordingId, publishedStatus] = args;

  await api.updateRecording({
    recordingId,
    published: publishedStatus,
  });
};

async function getRecordingById(
  args: types.GetRecordingByIdArgs,
): Promise<types.GetRecordingByIdResult> {
  const [recordingId] = args;

  const res = await api.getRecordingById({ recordingId });
  return normalize(res, recordingSchema);
}

async function getRecordings(
  args: types.GetRecordingsArgs,
): Promise<types.GetRecordingsResult> {
  const [recordingIds] = args;

  const result = await api.getRecordings({
    recordingIds,
  });

  return normalize(result.data, [recordingSchema]);
}

export const handle: types.IHandle = (
  method: types.ServiceMethod,
  args: any,
): Promise<any> => {
  switch (method) {
    case types.ServiceMethod.UPDATE_RECORDING:
      return updateRecording(args);

    case types.ServiceMethod.RECORDING_BY_ID_GET:
      return getRecordingById(args);

    case types.ServiceMethod.GET_RECORDINGS:
      return getRecordings(args);

    default:
      throw new Error(`${types.ACTION_KEY} cannot handle method ${method}`);
  }
};
